var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:['btn', 'btn-default', _vm.classicMode ? 'classic-mode' : 'btn-icon'],attrs:{"id":_vm.id},on:{"click":function($event){return _vm.$emit('click')}}},[_c(_vm.component,{tag:"component",style:({
      fill: _vm.color || undefined,
    }),attrs:{"id":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }